import React from 'react';
import AInputItem from 'antd-mobile/lib/input-item';



export default class InputItem extends AInputItem {}